import { ShipmentState } from "@freightsimple/generated-dashboard-openapi-client/models/ShipmentState";
import { mapsTokenColor } from "./mapsTokenColor";

// Resolved values, not `var(--…)`: these go to Mapbox, which hands them to
// WebGL rather than to CSS. It cannot parse a custom property, so the whole
// arc silently failed to draw.
export function pathColorForShipmentState(state: ShipmentState): string {
  const blue = () => mapsTokenColor("--color-blue", "#4c62ea");
  const midGray = () => mapsTokenColor("--color-mid-gray", "#71717a");
  switch (state) {
    case ShipmentState.Quoted:
      return blue();
    case ShipmentState.QuoteRequested:
      return blue();
    case ShipmentState.BookingConfirmed:
      return midGray();
    case ShipmentState.BookingRequested:
      return midGray();
    case ShipmentState.BookingFailed:
      return midGray();
    case ShipmentState.OnHold:
      return midGray();
    case ShipmentState.InTransit:
      return blue();
    case ShipmentState.Delivered:
      return mapsTokenColor("--color-dark-green", "#108922");
    case ShipmentState.Cancelled:
      return mapsTokenColor("--color-foreground", "#212838");
    case ShipmentState.Lost:
      return mapsTokenColor("--color-foreground", "#212838");
  }
}
